<template>
    <div class="full-space">
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        name: "DocumentApp"
    }
</script>

<style>
.full-space {
    padding: 5px;
    height: calc(100vh - 108px);
    overflow-y: scroll;
    overflow-x: hidden;

    background-color: azure;

}
</style>


